import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Inject international notice at top of drawer for non-US customers
     */
    if (window.Shopify && Shopify.country_code && Shopify.country_code !== 'US') {
      const drawerContainer = this.querySelector('.cart-items-component');
      if (drawerContainer && !drawerContainer.querySelector('.cart-international-notice')) {
        const notice = document.createElement('div');
        notice.className = 'cart-international-notice';
        notice.innerHTML = '<strong>International orders:</strong> Import duties, VAT, or customs fees may be charged by your country upon delivery. These charges are not included at checkout and are the responsibility of the buyer.';
        drawerContainer.insertBefore(notice, drawerContainer.firstChild);
      }
    }

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
